export type AlertSeverity = 'info' | 'warning' | 'success' | 'error'

export const AlertSeverityCode: Record<string, AlertSeverity> = {
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success',
  ERROR: 'error'
}